import { Col } from 'react-bootstrap'
import OwnSkeleton from './OwnSkeleton'

const CardProject = () => (<OwnSkeleton height={150} wrapperClassName="rounded" />)

const CardTestimonial = () => (
    <div className='mb-2 d-flex justify-content-between'>
        <div className='me-1'>
            <OwnSkeleton circle width={40} height={40} />
        </div>
        <div className='col px-4'>
            <OwnSkeleton count={4} />
        </div>
    </div>
)

const CardSkill = () => (
    <article className="d-flex flex-column w-100">
        <div className="col">
            <OwnSkeleton height={150} style={{borderRadius: "1.2rem"}} />
        </div>
        <div className="text-start mt-3 col">
            <OwnSkeleton height={25} />
            <OwnSkeleton count={3} style={{ marginBottom: ".6rem" }} />
        </div>
    </article>
)

const CardSkeleton = ({ cardsNumber, variant }) => {
    const VARIANT = {
        project: <CardProject />,
        testimonial: <CardTestimonial />,
        about: <CardSkill />
    }
    cardsNumber ||= 1

    return Array(cardsNumber).fill(0).map((_, index) => (
        <Col key={index} sm={6} md={6} lg={4} xs={12} className="py-2">
            {VARIANT[variant || "about"]}
        </Col>
    ))
}

export default CardSkeleton